import React from "react";

import { Loader } from "lucide-react";

interface PageLoaderProps {
  className?: string;
  show?: boolean;
}
const DialogLoader: React.FC<PageLoaderProps> = ({
  className = "",
  show = false,
}) => {
  const loaderRef = React.useRef<HTMLDivElement>(null);
  async function handleResize() {
    if (loaderRef.current) {
      const loader = loaderRef.current;
      const parent = loader.parentElement;
      loader.style.width = `${parent?.getBoundingClientRect().width}px`;
      loader.style.height = `${parent?.getBoundingClientRect().height}px`;
      loader.style.opacity = "1";
    }
  }

  setTimeout(() => {
    handleResize();
  }, 500);
  if (!show) return <></>;
  return (
    <div
      ref={loaderRef}
      className={`fixed transition-all duration-200 z-modal-level-3 bg-[#00000050] opacity-0 glass-2 ${className}`}
    >
      <Loader
        className="animate-spin absolute left-2/4 top-2/4 -mt-[28px] -ml-[28px]"
        size={50}
      />
    </div>
  );
};

export default DialogLoader;
